import { useMutation } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

interface IParams {
  readingTypeId: number;
  installationPointId: number;
  from?: number;
  range?: number;
}

const chartExportFn = (params: IParams) =>
  apiClient.get(`${APP_API_URL_V2}fsd/charts/csv`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });

export const useChartExportMutation = () => {
  return useMutation({
    mutationFn: chartExportFn,
  });
};
